import colors from '../../scss/_colors.scss'

export default {
  methods: {
    getThreadColor(type) {
      switch (type) {
        case 'common_message':
          return colors.hwayzMediumGray
        case 'offer_message':
          return '#B02BC7'
        case 'home_message':
          return colors.hwayzBlue
        case 'provide_feedback_message':
          return colors.hwayzTeal
        case 'route_schedule_message':
          return colors.hwayzDarkenGreen
        default:
      }
    }
  }
}
